export const cloudinary =
  "https://res.cloudinary.com/originenergy/image/upload/q_auto";

export const cloudinaryBaseUrl =
  "https://res.cloudinary.com/originenergy/image/upload/";

export const routes = {
  base: "/",
  customerRedirect: "/my-account/customer-redirect",
  myAccountSetup: "/my-account-setup/:customerType?",
  underConstruction: "/my/under-construction",
  spike: "/spike",
};

export const links = {
  login: "/auth/callback",
  myAccountSpike: "/my-account/spike/signup",
  register: "/auth/#/register/start",
  dashboard: "/my-account/dashboard",
};
